/* unplugin-vue-components disabled */import script from "./AlipayBaseConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlipayBaseConfig.vue?vue&type=script&setup=true&lang=ts"

import "./AlipayBaseConfig.vue?vue&type=style&index=0&id=294eb16c&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-294eb16c"]])

export default __exports__